module.exports = __webpack_public_path__ + "img/pairing-complete.9c022d5f.svg";